import { wrapDisplayName, withProps } from 'recompose'

export const withCompletionFlag = (propName, flagName, timeout = 3000) => WrappedComponent =>
    class extends Component {
        static displayName = `withCompletionFlag(${WrappedComponent.displayName})`

        constructor(props) {
            super(props)

            this.setFlag = this.setFlag.bind(this)
            this.startClearingFlag = this.startClearingFlag.bind(this)
            this.clearFlag = this.clearFlag.bind(this)

            this.state = {}
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            const value = this.props[propName]
            const nextValue = nextProps[propName]

            if (value && (!nextValue || nextValue instanceof Error)) this.setFlag()
            else if (nextValue) this.clearFlag()
        }

        setFlag() {
            this.setState(
                {
                    completed: true,
                },
                this.startClearingFlag
            )
        }

        startClearingFlag() {
            if (timeout > 0) setTimeout(this.clearFlag, timeout)
        }

        clearFlag() {
            this.setState({
                completed: false,
            })
        }

        render() {
            const props = {
                ...this.props,
                [flagName]: this.state.completed,
            }

            return <WrappedComponent {...props} />
        }
    }

export const withRouteParams = withProps(props => ({
    ...(props.match && props.match.params ? props.match.params : {}),
    ...(props.location ? props.location.query : {}),
}))

export const loadOnMount = (actionName, argsFromProps = () => [], test = () => true) => WrappedComponent =>
    class extends Component {
        static displayName = wrapDisplayName(WrappedComponent, 'loadOnMount')

        static propTypes = {
            children: PropTypes.any,
            [actionName]: PropTypes.func.isRequired,
        }

        componentDidMount() {
            if (test(this.props)) this.props[actionName](...argsFromProps(this.props))
        }

        render() {
            return <WrappedComponent {...this.props} />
        }
    }
